<template>
  <div class="max-w-md mx-auto bg-white shadow-lg rounded-lg p-6 space-y-6">
    <h2 class="text-xl font-semibold text-gray-900">الحصول على الشهادة</h2>

    <div class="bg-gray-100 p-4 rounded-lg xl:flex items-center space-x-4">
      <div class="w-10 h-10 flex items-center text-center md:m-auto xl:m-0 md:mb-2 justify-center bg-orange-100 rounded-full">
        <CheckIcon class="w-6 h-6 text-orange-500"/>
      </div>
      <div class="md:block md:mx-auto  xl:mx-0 xl:px-2">
        <h3 class="font-semibold flex justify-center text-gray-800 md:mx-auto xl:mx-0">لإنجاز المسار</h3>
        <p class="text-gray-600 text-sm flex justify-center md:mx-auto text-center xl:mx-0">
          تابع وخطط لإنجاز المسار وذلك بإتمام جميع الدورات التدريبية التي يتضمنها المسار والحصول على شهادة لكل دورة
        </p>
      </div>
    </div>

    <div>
      <h3 class="text-lg font-semibold text-gray-800">إنجازك في دورات المسار</h3>
      <div class="flex flex-col items-center">
        <div class="relative w-24 h-24">

          <Doughnut :data="data" :options="options"/>
          <div class="absolute inset-0 flex items-center justify-center text-lg font-bold">
            {{ completed_courses }}/{{ total_courses }}
          </div>

        </div>
        <p class="text-gray-600 text-sm mt-2">سوف يتم تحديد إنجازك في دورات المسار</p>
      </div>
    </div>

   <div class="bg-gray-100 p-4 rounded-lg">
  <h3 class="font-semibold text-gray-800">شهادة إتمام المسار التدريبي</h3>
  <a :href="redirect_to_certification">
    <button
        :disabled="!is_completed"
        :class="{
          'bg-[#277b9d] hover:bg-white cursor-pointer text-white hover:text-[#277b9d] hover:border-[#277b9d]': is_completed,
          'bg-gray-400 text-white cursor-not-allowed': !is_completed
        }"
        class="mt-2 px-2 w-full text-xs border-1 py-2 rounded-lg flex items-center justify-center">
      <DownloadIcon class="w-5 h-5"/>
      <span class="m-1">{{ is_not_last_viewed ? 'تحديث الشهادة' : 'تحميل الشهادة' }}</span>
    </button>
  </a>
     <p class="text-gray-600 text-xs mt-2">يتطلب رفع الشهادات 30 ثانية</p>
     <p v-if="show_new_courses_msg" class="text-gray-600 text-sm mt-2">تم إضافة دورات جديدة على المسار، قم بإتمامها للحصول على الشهادة</p>
</div>
  </div>
</template>

<script>
import { CheckIcon, DownloadIcon } from 'lucide-vue-next';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'vue-chartjs';

ChartJS.register(ArcElement, Tooltip, Legend);


export default {
  components: {
    Doughnut,
    CheckIcon,
    DownloadIcon
  },
  props: {
    total_courses: Number,
    completed_courses: Number,
    redirect_to_certification: String,
    is_completed: Boolean,
    is_not_last_viewed: Boolean,
    show_new_courses_msg: Boolean,
  },
  data() {
    return {
      options:
          {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
            },
            cutout: "70%", // Adjust thickness (higher value = thinner ring)

          }
      ,
      data: {
        datasets: [
          {
            backgroundColor: Array.from({length: this.total_courses}, (_,i) => i >= this.completed_courses ? '#BCCCBF' : '#1B8354'),
            data: Array.from({length: this.total_courses}, () => 100 / this.total_courses),
          }
        ]
      }
    };
  },
  methods: {},
};

</script>


<style>
/* Custom styles if needed */
</style>
